import React, { Component } from 'react';
import axios from 'axios'
import getQueryVariable from '~/tools/getQueryVariable'
import paypalButton from '~/assets/images/paypal-button.png'
import getCountryCode from '~/tools/userEnvironment/getCountryCode'
import './styles.scss'

class Paypal extends Component {
  state = {
    isLoading: false,
    error: ''
  }

  componentDidMount() {
    const token = getQueryVariable('token')

    if (this.props.currentPlan) {
      localStorage.setItem('currentPlan', JSON.stringify(this.props.currentPlan))
    }

    if (token) {
      this.loadingScreen()
      executeAgreement(token).then(response => {
        const { data } = response;
        const vlTransactionId = data.id
        this.props.subscribe(vlTransactionId)
      }).catch(error => {
        this.handleError()
        throw new Error(error)
      })
    }
    
    async function executeAgreement() {
      const site = window.settings.internalName
      return await axios.post(`${window.settings.apiBaseUrl}/subscription-misc/paypal/execute`, { token, site })
    }
  }

  loadingScreen = () => {
    this.props.overlay({ styles: { backgroundColor: '#a9a9a5b0', zIndex: 2 }, loading: true })
  }

  handleError = () => {
    this.props.overlay({ styles: {display: 'none'}, loading: false })
  }

  paypalHandler = async(e) => {
    e.preventDefault()
    this.loadingScreen()
    const isoDate = new Date();
    isoDate.setSeconds(isoDate.getSeconds() + 100)
    const { currentPlan } = this.props

    let params = {
      billingAgreementAttributes: {
        site: window.settings.internalName,
        name: currentPlan.name,
        description: 'viewlift',
        start_date: isoDate,
        plan: {
          id: currentPlan.id
        },
        payer: {
          payment_method: 'paypal'
        },
      }
    }

    try {
      const countryCode = await getCountryCode()
      params.billingAgreementAttributes.countryCode = countryCode || 'US'
      const paypalInfo = await axios.post(`${window.settings.apiBaseUrl}/subscription-misc/paypal/subscribe`, params)
      const { data } = paypalInfo
      window.location = data.approval_url
    } catch(err) {
      console.log(err)
      this.handleError()
    }
  }

  render() {       
    return (  
      <div className='paypal-button'>
        <button disabled={this.props.disabled} onClick={(e) => this.paypalHandler(e)}>
          <img src={paypalButton} alt="Check out with PayPal" />        
        </button>
      </div>
    )
  }
}

export default Paypal;